import React from "react";

const LikeSVG = ({ type = "like", color = "#6570FC", liked }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill={liked ? "#6570fc" : "none"}
      xmlns="http://www.w3.org/2000/svg"
      style={{
        rotate: `${type === "dislike" ? "180deg" : "0deg"}`,
      }}
    >
      <g clipPath="url(#clip0_24_1284)">
        <path
          d="M4.66668 14.6666H2.66668C2.31305 14.6666 1.97392 14.5262 1.72387 14.2761C1.47382 14.0261 1.33334 13.6869 1.33334 13.3333V8.66665C1.33334 8.31302 1.47382 7.97389 1.72387 7.72384C1.97392 7.47379 2.31305 7.33331 2.66668 7.33331H4.66668M9.33334 5.99998V3.33331C9.33334 2.80288 9.12263 2.29417 8.74756 1.9191C8.37248 1.54403 7.86378 1.33331 7.33334 1.33331L4.66668 7.33331V14.6666H12.1867C12.5082 14.6703 12.8203 14.5576 13.0653 14.3493C13.3103 14.1411 13.4718 13.8513 13.52 13.5333L14.44 7.53331C14.469 7.34222 14.4561 7.1471 14.4022 6.96148C14.3483 6.77586 14.2547 6.60418 14.1279 6.45832C14.0011 6.31247 13.8441 6.19593 13.6677 6.11679C13.4914 6.03765 13.2999 5.99779 13.1067 5.99998H9.33334Z"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>

      <defs>
        <clipPath id="clip0_24_1284">
          <rect width="16" height="16" fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default LikeSVG;
